// client/src/pages/Refund.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Refund() {
  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-10"
      >
        <Link to="/" className="inline-flex items-center justify-center gap-3">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold tracking-wide">SMSOrbit</span>
        </Link>
        <h1 className="mt-6 text-3xl md:text-4xl font-bold">Refund Policy</h1>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="max-w-4xl mx-auto rounded-3xl bg-[#090912] border border-white/5 p-8 md:p-10 text-sm md:text-base text-gray-200 space-y-4 leading-relaxed"
      >
        <p>
          Payments to SMSOrbit are converted to panel balance and are generally
          non-refundable. Please double-check the amount and currency before
          submitting a payment.
        </p>
        <p>
          If a service is not delivered or only partially delivered, the
          undelivered portion will be automatically refunded to your SMSOrbit
          balance. You can then use those funds to place new orders.
        </p>
        <p>
          Filing a payment dispute or chargeback may result in immediate
          suspension of your account and removal of delivered services.
        </p>
      </motion.div>
    </div>
  );
}
